<template>
  <div>
    <div style="width: 100%;height: 100%;color: #fff;">
      <div class="tip-head">
        <div style="display: inline-block;width: 65%;font-size: 24px;font-weight: bold">10.0.6.54</div>
        <div style="display: inline-block;width: 30%;font-size: 18px;">已连接</div>
        <div class="tip-head-dot"></div>
      </div>
      <div class="tip-li">操作系统：centos 7.9.2009</div>
      <div style="margin-top: 10px;">
        <div class="progress-text">
          <t-progress theme="circle" :percentage="25" :stroke-width="10"></t-progress>
        </div>
        <div class="progress-text">
          <t-progress theme="circle" :percentage="72" :stroke-width="10" color="#e6a23c"></t-progress>
        </div>
        <div class="progress-text">
          <t-progress theme="circle" :percentage="88" :stroke-width="10" color="#ff4949"></t-progress>
        </div>
      </div>
      <div>
        <div class="progress-text">
          <div>CPU</div>
        </div>
        <div class="progress-text">
          <div>ROM</div>
          <div>5603/8200 GB</div>
        </div>
        <div class="progress-text">
          <div>RAM</div>
          <div>14.5/16 GB</div>
        </div>
      </div>
      <div class="tip-li">设备型号： HUAWEI k40lb-5000</div>
      <div class="tip-li">固资编号： S6548213547435877</div>
      <div class="tip-li">上架时间： 2022-10-19</div>
      <div class="tip-li">主要维护人： 张三</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "server-tips"
}
</script>

<style scoped>
.tip-head{background-color: #edf2fc;line-height: 40px;text-align: center;position: relative;
  border-radius: 0 8px 0 8px;color: #0267da}
.tip-head-dot{position: absolute;right: 10px;top: 16px;width: 12px;height: 12px;border-radius: 12px;background-color: #5daf34}
.tip-li{line-height: 36px;text-indent: 1em;background-color: #bbbbbb98;margin-top: 4px}
.progress-text{display: inline-block;width: 32%;text-align: center;}
</style>
